import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    button: {
      right: '26px',
      marginLeft: '25px',
      top: '20px',
      height: '30px',
      fontSize: '12px',
    },
    resultScreen: {
      width: '466px',
      height: '292px',
      textAlign: 'center',
    },
  }),
);
